<si-landing-page
  backgroundImageUrl="assets/images/backgroundImage.webp"
  [heading]="applicationTitle"
  [subtitle]="applicationClaim"
  [copyrightDetails]="copyrightDetails"
  [links]="[
    {
      title: 'Corporate Information',
      href: 'http://www.siemens.com/corporate-information'
    },
    { title: 'Privacy Notice', href: 'http://www.siemens.com/privacy-notice' },
    { title: 'Terms of Use', href: 'http://www.siemens.com/terms-of-use' }
  ]"
  [availableLanguages]="availableLanguages"
>
  <form>
    <div class="mb-4"> </div>
    <button type="button" class="btn btn-primary mt-8 w-100" (click)="onLoginClicked()">
      {{ 'APP.LOGIN' | translate }}
    </button>
  </form>
  <br />
  <div class="si-title-2 text-secondary mt-8">{{ 'APP.PRODUCTIVE_DATA.HEADING' | translate }}</div>
  <div class="si-body-2 text-secondary mt-4">
    {{ 'APP.PRODUCTIVE_DATA.WARNING' | translate }}
  </div>
</si-landing-page>
